import { BaseSerializer } from './base.serializer'
import { Program } from 'models/program.model'
import { CenterProgramSerializer } from './center-program.serializer'
import { ProgramSectionSerializer } from './program-section.serializer'
import { MotivationVideoSerializer } from './motivation-video.serializer'

export class ProgramSerializer extends BaseSerializer<Program> {
  static SERIALIZABLE_ATTRIBUTES = [
    'centerIds', 'comment', 'folderId', 'name', 'password', 'sections',
    'timeLimit', 'minGrade', 'nestedProgramIds',
    'yandexMinExportGrade', 'yandexMinExportGradeEnabled',
    'course', 'motivationVideos', 'equivalentIds', 'requiredApi', 'kioskUuid'
  ]
  static SERIALIZERS = {
    sections: ProgramSectionSerializer,
    motivationVideos: MotivationVideoSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    sections: 'sectionsAttributes',
    motivationVideos: 'motivationVideosAttributes'
  }

  static DESERIALIZERS = {
    centerPrograms: CenterProgramSerializer,
    sections: ProgramSectionSerializer,
    motivationVideos: MotivationVideoSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): Program {
    return new Program(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/program.serializer.ts